import { useEffect, useState } from 'react';

import { Message as AiMessage } from '@ai-sdk/react';

const hasAttachment = (message: AiMessage) =>
  message.parts?.some(
    (part) => part.type === 'tool-invocation' && part.toolInvocation?.toolName === 'save_draft_study_to_scratchpad'
  );

export const useAutoOpenUserAction = (messages: AiMessage[], openContent: (messageId: string) => void) => {
  const [seenIds, setSeenIds] = useState<string[]>([]);

  useEffect(() => {
    const newMessageWithUpdateStudyTool = messages.find((message) => {
      if (seenIds.includes(message.id)) {
        return false;
      }

      if (hasAttachment(message)) {
        setSeenIds((prev) => [...prev, message.id]);
        return true;
      }

      return false;
    });

    if (newMessageWithUpdateStudyTool) {
      openContent(newMessageWithUpdateStudyTool.id);
    }
  }, [messages, openContent, seenIds]);
};
